const backdropSepia = {
    name: "backdrop-sepia",
    path: "/backdrop-sepia",
    title: "backdrop-sepia",
    description: "Utilities for applying backdrop-sepia filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-sepia':'sepia(100%)',
            'backdrop-sepia-<number>': 'sepia(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "backdrop-sepia-50, backdrop-sepia-100",
            "description": "to control an element's backdrop-sepia:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-sepia-0",
                        "text": "backdrop-sepia-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-sepia-50",
                        "text": "backdrop-sepia-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-sepia",
                        "text": "backdrop-sepia",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-sepia-0" src="/img/mountains.jpg" />
<img class="backdrop-sepia-25" src="/img/mountains.jpg" />
<img class="backdrop-sepia" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropSepia;